import React from 'react';

interface TabProps {
  tabs: string[];
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const Tab: React.FC<TabProps> = ({ tabs, activeTab, onTabChange }) => (
  <div className="flex items-center justify-between mb-4">
    <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => onTabChange(tab)}
          style={{
            padding: '0.5rem 1rem',
            borderRadius: '6px',
            borderRight: activeTab === tab ? '5.62px solid #D12929' : '5.62px solid #474646',
            borderLeft: activeTab === tab ? '5.62px solid #D12929' : '5.62px solid #474646',
            color: '#fff',
            cursor: 'pointer',
            backgroundColor: 'transparent',
          }}
        >
          {tab}
        </button>
      ))}
    </div>
  </div>
);

export default Tab;
